var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurringIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#10F0A6",
    fillRule: "evenodd",
    d: "M12 6c.685 0 1.241.448 1.241 1v.704c.757.102 1.427.412 1.916.851.284.256.508.557.654.89.229.52-.11 1.092-.756 1.276-.647.184-1.356-.09-1.585-.61a.655.655 0 0 0-.163-.222.92.92 0 0 0-.617-.222h-1.602c-.334 0-.605.218-.605.487 0 .23.198.428.476.477l2.438.43c1.52.267 2.603 1.352 2.603 2.605 0 1.321-1.193 2.419-2.759 2.63V17c0 .552-.556 1-1.241 1-.686 0-1.241-.448-1.241-1v-.704c-1.198-.161-2.176-.841-2.57-1.74-.229-.521.11-1.093.756-1.277.647-.184 1.356.09 1.585.61.114.26.422.444.78.444h1.38c.456 0 .827-.298.827-.667 0-.314-.271-.585-.65-.652l-2.439-.43C9.011 12.335 8 11.325 8 10.155c0-1.284 1.208-2.34 2.759-2.473V7c0-.552.555-1 1.24-1Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0EC78A",
    fillRule: "evenodd",
    d: "M4.372 12a7.627 7.627 0 0 1 13.73-4.577 1.186 1.186 0 1 0 0 2.373h1.989c.032.002.064.002.096 0h.627c.655 0 1.186-.531 1.186-1.186V5.898a1.186 1.186 0 0 0-2.33-.315A9.978 9.978 0 0 0 12 2C6.477 2 2 6.477 2 12a1.186 1.186 0 1 0 2.372 0ZM22 12a1.186 1.186 0 1 0-2.373 0 7.627 7.627 0 0 1-13.73 4.576h.002a1.186 1.186 0 1 0 0-2.373H3.187c-.655 0-1.187.531-1.187 1.187v2.712a1.186 1.186 0 0 0 2.33.316A9.979 9.979 0 0 0 12 22c5.523 0 10-4.477 10-10Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurringIcon);
export default __webpack_public_path__ + "static/media/recurring-icon.15252a8f1652eadd747891093d9900ca.svg";
export { ForwardRef as ReactComponent };